import { LPEFEEDBACK_APP_NAME } from '../constants';
import { store } from '../../store';
import { LPEFeedback } from '../../schemas/LPEFeedback/LPEFeedback.schema';
import { logFeedbackData } from '../../actions/LPEFeedback/action';
import { isPlatform } from '@ionic/react';
import { dayjs } from '../Date/DateUtil';
export class LPESource implements LPEFeedback.ILPESource {

  /**
   * Defined the variables and functions of the interface ILPESource
   */

    sourceName = "LPESource";
    public logFeedbackEvents(name: string, params: LPEFeedback.ILPESourceProperties): Promise<void> {
        store.dispatch(logFeedbackData(params));
        return Promise.resolve();
    }

    /**
     * 
     * @param name LPE Feedback EventName
     * @param parameters parameter that needs to be send as Event data (same as Firebase params)
     * @param sessionFields session data if available in the components
     * @returns contructed payload the needs to be send in the API
     */
    getFeedbackPayloadData(
        name: string,
        parameters: object,
        sessionFields: string[]) : LPEFeedback.ILPESourceProperties{
    
            let params: any = parameters;
            let data : LPEFeedback.ILPESourceProperties = {};
            let platform = "";
    
            if (name) {
                const storeData = store.getState();
                const session = storeData && storeData.App && storeData.App.session;

                platform = (isPlatform('desktop') || isPlatform('mobileweb')) ? "Web" : "Mobile";
                params = { ...params, channel: platform };
            
                if (session) {
                  params = { ...params, sessionId: getSessionId(session.uuid) };
                  /**
                   *  Session Fields Array includes required fields  from session
                   */
                  sessionFields.forEach(field => {
                    params[field] = session[field] || '';
                  });
                }
                
              }

              // Construct the final data to dispatch
                data.eventDateTime = new Date().toISOString();
                // Backend expects eventData to be in json format
                data.eventData = params ? params : {};
                data.appName = LPEFEEDBACK_APP_NAME;
                data.eventType = name ? name : "";
    
            return data;
    
    }

}

/**
 * 
 * @param id session ID
 * @returns id appended with the current time
 */

const getSessionId = (id: string): string => {
    return id + dayjs(new Date()).format('MMDDYYYYHHmmss');
};
